import { i18n } from '@i18n';
import { openModalSelector, useModalStore } from '@store';

export function useTravellersInfoModal() {
  const openModal = useModalStore(openModalSelector);
  return {
    openMoreInfoModal(modalType?: string) {
      return openModal('Modal', {
        body: {
          type: 'MoreInfoModalBody',
          modalType,
        },
        actions: [
          {
            title: i18n.t('travellers.residentStatus.modal.actions.ok'),
            variant: 'primary',
          },
        ],
      });
    },
  };
}
